import http from "./http-common";
import Crypto from "./Crypto";
import { getServidor } from "../utils/Utils";

/**
 * Clase del servicio de marcadores que permite consultar, almacenar, actualizar y eliminar.
 */


class MarcadoresDataService{
  
    /**
     * @brief Obtiene el listado completo de marcadores.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición con los marcadores.
     */
    getAll() {
      return http.get(`${getServidor()}/marcadores/`);
    }
    /**
     * @brief Registra un nuevo marcador.
     *
     * @param data Datos del marcador a registrar.
     * @param key Clave utilizada para encriptar los datos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP.
     */
    async create(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.post(`${getServidor()}/marcadores/`, datosEncriptados);
    }

    /**
     * @brief Elimina un marcador existente.
     *
     * @param id Identificador del marcador a eliminar.
     * @param key Clave utilizada para encriptar los datos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP.
     */
    async delete(id, key){
      const datosEncriptados = await Crypto.encriptar(id, key);
      return http.delete(`${getServidor()}/marcadores/`, {
        params: datosEncriptados
      });
    }

    /**
     * @brief Actualiza los datos de un marcador existente.
     *
     * @param data Datos del marcador a actualizar.
     * @param key Clave utilizada para encriptar los datos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición HTTP.
     */
    async update(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.put(`${getServidor()}/marcadores/`, datosEncriptados)
    }

}
/**
 * Variable para exportar
 */
export default new MarcadoresDataService();